// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-2554282a] .el-dialog {\n  height: 107% !important;\n  margin-top: 10px !important;\n}\n.box[data-v-2554282a] .el-dialog__footer {\n  padding: 0px 20px 20px;\n}\n.box[data-v-2554282a] .el-dialog__wrapper {\n  height: 112% !important;\n  overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
